import { Form, Input, InputNumber, Select, Switch } from 'antd';
import { useEffect } from 'react';

interface FormField {
  key: string;
  label: string;
  type: 'text' | 'number' | 'select' | 'boolean' | 'textarea';
  options?: string[];
  value?: unknown;
}

interface FormContent {
  fields: FormField[];
  values: Record<string, unknown>;
}

interface FormRendererProps {
  content: FormContent;
  editable: boolean;
  onChange: (newContent: FormContent) => void;
}

function FormRenderer({ content, editable, onChange }: FormRendererProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(content.values);
  }, [content.values, form]);

  const handleValuesChange = (_: unknown, allValues: Record<string, unknown>) => {
    onChange({ ...content, values: allValues });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      disabled={!editable}
      onValuesChange={handleValuesChange}
      initialValues={content.values}
    >
      {content.fields.map((field) => (
        <Form.Item key={field.key} label={field.label} name={field.key}>
          {renderFieldInput(field)}
        </Form.Item>
      ))}
    </Form>
  );
}

function renderFieldInput(field: FormField) {
  switch (field.type) {
    case 'number':
      return <InputNumber style={{ width: '100%' }} />;
    case 'select':
      return (
        <Select>
          {(field.options ?? []).map((opt) => (
            <Select.Option key={opt} value={opt}>
              {opt}
            </Select.Option>
          ))}
        </Select>
      );
    case 'boolean':
      return <Switch />;
    case 'textarea':
      return <Input.TextArea rows={3} />;
    default:
      return <Input />;
  }
}

export default FormRenderer;
